import Header from "../../components/MarginalsV2/Header";
import SignInModal from "../../components/forms/Modals/SignInModal";
import Footer from "../../components/MarginalsV2/Footer";
import { useCallback, useState, useEffect } from "react";
import MainVerifyModal from "../../components/forms/Modals/MainVerifyModal";
import useStateWithLocalStorage from "../../helpers/useStateWithLocalStorage";
import { isValid } from "../../helpers/auth";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";

export default function Login() {
  const [didSubmit, setDidSubmit] = useState(false);
  const [token, setToken] = useStateWithLocalStorage("token");
  const navigate = useNavigate();
  const { lang } = useParams();

  // Redirect authenticated users to account page
  useEffect(() => {
    if (token && isValid(token)) {
      navigate(`/${lang}/account`, { replace: true });
    }
  }, [token, navigate, lang]);

  const callback = useCallback((didSubmit) => {
    setDidSubmit(didSubmit);
  }, []);

  return (
    <>
      <Header renderBg={true} className="py-2" />
      {!didSubmit && <SignInModal parentCallback={callback} />}
      {didSubmit && <MainVerifyModal />}
      <Footer />
    </>
  );
}
